module.exports = __webpack_public_path__ + "static/p12_F_becerroCuerpo-5d3fe385b8c3c70b632e61e2ad69f58f.png";